import StoreStatusSelect from './StoreStatusSelect'

export default StoreStatusSelect
